__turbopack_context__.v({
  "className": "HGVREa_className",
  "variable": "HGVREa_variable",
});
